import { useState } from "react";
import { faqList } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600">
              <i className="ri-question-line" aria-hidden />
              常见问题
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              先看这里，能省掉一半疑问
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              下面是读者问得最多的六个问题。如果还有没覆盖到的，把问题发到页面底部的联系邮箱即可。
            </p>
            <a
              href="#about"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-mail-send-line" aria-hidden />
              去联系我们
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-50 md:px-6"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i
                            className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                            aria-hidden
                          />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}